import classnames from 'classnames';
import * as React from 'react';

import { ConversationTimestamp } from 'components/conversation/components/conversationTimestamp/conversationTimestamp';

import sharedStyles from '../message/message.module.scss';

import styles from './messageStatus.module.scss';

export interface MessageStatusProps {
  /** Extra classnames */
  className?: string;
  /** The message text */
  text: string;
  /** Timestamp */
  date: string;
  /** Is this the newest message? */
  newest?: boolean;
}

export const MessageStatus: React.FunctionComponent<MessageStatusProps> = ({
  className,
  text,
  date,
  newest,
  ...otherProps
}) => {
  const rootClass = classnames(
    {
      [styles.messageStatus]: true,
    },
    className,
  );

  return (
    <div {...otherProps} className={rootClass}>
      {text}
      <div className={styles.date}>
        {!!date && (
          <ConversationTimestamp
            time={date}
            relative={newest}
            shouldDateFormatPersist={!newest}
            textProps={{ className: sharedStyles.timestamp }}
          />
        )}
      </div>
    </div>
  );
};
